import { getCompletedStatusForSectionKey } from './constants/survey_sections';

export const sectionCompleted = (sectionKey, surveyState) => {
  if (!surveyState || !sectionKey) {
    return false;
  }

  return !!surveyState[getCompletedStatusForSectionKey(sectionKey)];
};

// Index of furthest completed section. Not zero-indexed. Returns 0 if no progress has been made.
const furthestCompletedSection = (sectionKeys, completedValues) => {
  for (let sectionIndex = sectionKeys.length - 1; sectionIndex >= 0; sectionIndex -= 1) {
    const sectionKey = sectionKeys[sectionIndex];

    if (sectionCompleted(sectionKey, completedValues)) {
      return sectionIndex + 1;
    }
  }

  return 0;
};

// Computes the progress based on a list of section keys and completed values
//
// sectionKeys should be in ascending order (last element of the list indicates the most progress)
// completedValues should be a map with completion data for the sections
//
// Formula for progress is: Math.min(((furthestCompletedSection / totalSections ) + motivationalProgress) * 100, 100)
// The motivationalProgress value is an amount of progress given regardless of completed sections. It is 0.45 of the progress that would
// have been given for completing a full section.
export const computeProgressPercentage = ({ sectionKeys, completionData }) => {
  if (sectionKeys.length < 2) {
    throw new Error('Minimum number of sections for the progress bar component is 2');
  }

  const motivationalProgressRatio = 0.45;
  const numSections = sectionKeys.length;
  const progress = furthestCompletedSection(sectionKeys, completionData) / numSections;
  const motivationalProgress = (1 / numSections) * motivationalProgressRatio;
  const progressPercentage = (progress + motivationalProgress) * 100;

  return Math.min(progressPercentage, 100);
};

export const isBlank = value => {
  let isEmptyArray = false;

  if (Array.isArray(value)) {
    isEmptyArray = value.length === 0;
  }

  return value === null || value === undefined || value === '' || isEmptyArray;
};

export const isValidZipCode = text => {
  return /^\d{5}([-]|\s*)?(\d{4})?$/.test(text);
};

export const scrollToElement = ({ elementName, viewportWidth }) => {
  const element = document.getElementsByName(elementName)[0];

  if (viewportWidth < 576) {
    // For mobile we want it to scroll to the top but right below the header
    // So we need to calculate and apply an offset of the height of the header
    const yCoordinate = element.getBoundingClientRect().top + window.pageYOffset;
    const offset = -90;

    window.scrollTo({
      top: yCoordinate + offset,
      behavior: 'smooth',
    });
  } else {
    // For desktop we want to scroll to the center of the viewport
    const rect = element.getBoundingClientRect();
    const yCoordinate = rect.top + window.pageYOffset; // y position of where our element is relative to the entire page
    const elementHeight = rect.height;
    const windowHeight = window.innerHeight;
    const centeringOffset = windowHeight / 2 - elementHeight / 2; // The offset needed to make element centered relative to the element being at the top of the viewport
    const offset = elementHeight < windowHeight ? centeringOffset : 0;

    window.scrollTo({
      top: yCoordinate - offset,
      behavior: 'smooth',
    });
  }
};
